export type WebSocket = {
  connectingWS: boolean
  connectedWS: boolean
  error?: string
}

export const initialState: WebSocket = {
  connectingWS: true,
  connectedWS: false,
}

export enum ActionTypes {
  CONNECTING_WS = 'CONNECTING_WS',
  CONNECTED_WS = 'CONNECTED_WS',
  ERROR_WS = 'ERROR_WS',
}
